import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IPublishedConnectionColumn } from '../../../publishedConnectionTable/serverApi/types/IPublishedConnectionTable';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';

export interface IGetPublishedConnectionColumnsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionColumnsResult extends IGetItemsResult {
  publishedConnectionColumns?: IPublishedConnectionColumn[];
}

export class GetPublishedConnectionColumnsRequest extends Request<IGetPublishedConnectionColumnsParams, IGetPublishedConnectionColumnsResult> {
  constructor(params: IGetPublishedConnectionColumnsParams) {
    super('getPublishedConnectionColumns', params);
  }
}
